export const AUTH_SESSION_MAX_AGE_SECONDS = 7 * 24 * 60 * 60;
export const AUTH_SESSION_MAX_AGE_MS = AUTH_SESSION_MAX_AGE_SECONDS * 1000;
export const EMAIL_SIGN_IN_LINK_MAX_AGE_SECONDS = 15 * 60;
